export default __webpack_public_path__ + "static/media/illustration_recruit.395bb8fc.svg";